import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-hero-video',
  templateUrl: './hero-video.component.html',
  styleUrls: ['./hero-video.component.scss']
})
export class HeroVideoComponent implements OnInit {
  @Input() backgroundImage: string;
  @Input() fillHeight = false;
  @Input() overlayOpacity = 0;
  @Input() vimeoId;

  constructor(private sanitize: DomSanitizer) { }

  ngOnInit() {
  }

  safeStyle(style: string): SafeStyle {
    return this.sanitize.bypassSecurityTrustStyle(style);
  }

}
